import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";
import type { EmployeeLocationDescription } from "app/pages/sales-intelligence/modules/leads-search-filters/types/description.dto";
import type { ISiCountryService } from "app/pages/sales-intelligence/services/siCountryService";

import EmployeeLocationFilter from "../../components/filters/EmployeeLocationFilter/EmployeeLocationFilter";
import EmployeeLocationFilterResult from "../../components/filters/EmployeeLocationFilter/EmployeeLocationFilterResult";
import { contactsFilterCategoryMap } from "../../types/contactsFilterCategory";

import FindEmployeeLocationFilter from "./EmployeeLocationFilter";

const createEmployeeLocationFilter = (
    { inclusions }: EmployeeLocationDescription,
    filtersCountryService: ISiCountryService,
): SearchFilterInstance => {
    return {
        key: "employeeLocation",
        trackingName: "Employee Location",
        apiCategory: "contactsFilters",
        title: { key: "si.lead_gen_filters.employee_location" },
        tooltipText: { key: "si.lead_gen_filters.category.employee_location.tooltip" },
        filter: new FindEmployeeLocationFilter({
            options: {
                inclusions: inclusions,
                countries: filtersCountryService.allCountries,
                regions: filtersCountryService.allRegions,
            },
        }),
        filterView: EmployeeLocationFilter,
        filterResultView: EmployeeLocationFilterResult,
        category: contactsFilterCategoryMap.contacts,
    };
};

export default createEmployeeLocationFilter;
